/**
 * CSRF Token Store
 * Manages CSRF tokens for protecting against Cross-Site Request Forgery attacks
 */

import { create } from 'zustand';

interface CsrfState {
  token: string | null;
  setToken: (token: string) => void;
  clearToken: () => void;
}

export const useCsrfStore = create<CsrfState>((set) => ({
  token: null,
  setToken: (token) => set({ token }),
  clearToken: () => set({ token: null }),
}));
